module.exports = "<div *ngIf=\"errorMessages !== null\">{{errorMessage}}</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/control-messages/control-messages.component.html
// module id = ../../../../../src/app/control-messages/control-messages.component.html
// module chunks = main